<template>
  <div class="project-approval-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>项目管理</h2>
      </div>
    </div>
    <!-- 筛选区域 -->
    <div class="project-title">
      <span class="project-title-list" v-for="list in pageTypeList" @click="hanlderPageType(list)"
        :class="list.value == pageType ? 'active' : ''" :key="list.value">{{ list.label }}</span>
    </div>
    <div class="project-type whitebox">
      <ul class="oh my-2">
        <li class="project-type-list" v-for="list in projectTypeList" @click="hanlderProjectType(list)"
          :class="searchFilter.dataSource == list.value ? 'active' : ''" :key="list.value">
          {{ list.label }}<span v-show="list.num > 0">({{ list.num }})</span></li>
      </ul>
    </div>
    <!-- 数据表格区域 -->
    <div class="table-section">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-document-checked"></i>
          <span>建设项目</span>
          <el-tag size="small" type="info">{{ total }} 条</el-tag>
        </div>
      </div>

      <el-table :data="tableData" stripe border v-loading="loading" class="data-table"
        v-show="searchFilter.dataSource == 1" :header-cell-style="headerCellStyle">
        <el-table-column prop="index" width="60" align="center" label="序号">
          <template slot-scope="{ $index }">
            {{ $index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>

        <el-table-column prop="projectName" label="项目名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false"
              @click="todoDetail(row)">
              {{ row.projectName }}
            </el-link>
          </template>
        </el-table-column>


        <el-table-column prop="approveDate" label="城市" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.province }}{{ row.city }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="建设单位" min-width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.companyName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="approveDate" label="投资额" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.money == 0 ? '-' : row.money + row.moneyUnit }}
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="完成时间" width="180" align="center">
          <template slot-scope="{ row }">
            {{ row.finishDate || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" :class="row.preselectId ? 'red-color' : ''" v-if="pageType == 1"
              @click="togglePreselectProject(2, row)">
              {{ row.preselectId > 0 ? '取消' : '加入' }}预选项目
            </el-button>
            <el-button type="text" size="small" :class="row.isProject ? 'red-color' : ''" @click="toggleProject(row)">
              {{ row.isProject ? '取消' : '加入' }}项目管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="tableData" stripe border v-loading="loading" class="data-table"
        v-show="searchFilter.dataSource == 2" :header-cell-style="headerCellStyle">
        <el-table-column prop="index" width="60" align="center" label="序号">
          <template slot-scope="{ $index }">
            {{ $index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="160" align="left" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false"
              @click="todoDetail(row)">
              <span class="code-text">{{ row.projectName || '-' }}</span>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="projectCode" label="中选机构" min-width="130" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="code-text">{{ row.companyName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectCode" label="项目规模" align="center" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="code-text">{{ row.money == 0 ? '-' : row.money + row.moneyUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="城市" width="170" align="center">
          <template slot-scope="{ row }">
            {{ row.province }}{{ row.city }}{{ row.county }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="合同时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.finishDate || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" :class="row.preselectId ? 'red-color' : ''" v-if="pageType == 1"
              @click="togglePreselectProject(2, row)">
              {{ row.preselectId > 0 ? '取消' : '加入' }}预选项目
            </el-button>
            <el-button type="text" size="small" :class="row.isProject ? 'red-color' : ''" @click="toggleProject(row)">
              {{ row.isProject ? '取消' : '加入' }}项目管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
          background />
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'projectManagement',
  components: {

  },
  data() {
    return {
      pageTypeList: [{ label: '预选项目名单', value: 1 }, { label: '项目管理', value: 2 }],
      pageType: 1,
      projectTypeList: [{ label: '政府审批项目', value: 1 }, { label: '产业链上游项目', value: 2 }],
      // 表格数据
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchFilter: {
        dataSource: 1,
        projectName: '',
      },
      dataTypeList:[
        {id:1,name:'审批公告',link:'/examineNotice/detail'},
        {id:2,name:'核准公告',link:'/ApprovalNotice/detail'},
        {id:3,name:'备案公开',link:'/RecordPublic/detail'},
        {id:4,name:'环境影响评价报告',link:'/EiaReport/detail'},
        {id:5,name:'节能审查',link:'/EnergyNotice/detail'},
        {id:6,name:'建设项目用地预审与选址意见书',link:'/LandPreapproval/detail'},
        {id:7,name:'拿地公告',link:'/landSearch/detail'},
        {id:8,name:'建设用地规划许可证',link:'/LandPermit/detail'},
        {id:9,name:'工程规划许可证',link:'/ConstructionPermit/detail'},
        {id:10,name:'招投标"',link:'/tenderingBidding/detail'},
      ],

    }
  },
  mounted() {
    if (this.pageType == 2) {
      this.getProject();
    } else if (this.pageType == 1) {
      this.getPreselectProject();
    }
  },


  methods: {
    todoDetail(row) {
      console.log(row,this.pageType,this.searchFilter.dataSource);
      if(this.pageType == 2){
       this.handlerLinkLocal('projectDetail?id=' + row.id + '&dataSource=' + row.sourceType + '&sourceType=' + row.sourceType + '&detail=' + row.detail);
      }else{
        //详情页跳转需要先判断类型再决定跳到哪个详情 
        if(this.searchFilter.dataSource == 1){
            //对比数据类型dataTypeList
            this.dataTypeList.forEach(item => {
              if (item.id == row.sourceType) {
                let routeUrl = this.$router.resolve({
                    path: item.link+'?id='+row.sourceId, 
                });
                window.open(routeUrl.href, '_blank');  
              }
            }) 
        }else{
            if(row.detail == 'Detail'){
                  this.handlerLinkLocal('/agencyService/detail?id=' + row.sourceId);
              }else if(row.detail == 'DetailGD'){  //广东
                  this.handlerLinkLocal('/agencyService/detailGD?id=' + row.sourceId);
              }else if(row.detail == 'DetailSZ'){  //深圳
                  this.handlerLinkLocal('/agencyService/detailSZ?id=' + row.sourceId);
              }else{  //其他
                  this.handlerLinkLocal('/agencyService/detail?id=' + row.sourceId);
              }
        }
        }
      

      
    },
    // 获取数据
    getPreselectProject() {
      this.loading = true;
      let ajaxUrl = this.$api.common.preselectProject.List();
      let params = {
        page: this.currentPage,
        ...this.searchFilter
      }
      //排除空值
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key];
      })
      this.$axios.get(ajaxUrl, { params }).then((res) => {
        console.log('全部数据', res);
        //将list里面的id 赋值给preselectId，用于判断是否是预选项目
        res.list.forEach(item => {
          item.preselectId = item.id;
        });
        this.tableData = res.list;

        this.total = res.totalRecord;
        if (this.searchFilter.dataSource == 1) {
          this.projectTypeList[0].num = res.totalRecord;
        }
        if (this.searchFilter.dataSource == 2) {
          this.projectTypeList[1].num = res.totalRecord;
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false
      })
    },
    getProject() {
      this.loading = true;
      let ajaxUrl = this.$api.common.project.List();
      let params = {
        page: this.currentPage,
        ...this.searchFilter
      }
      //排除空值
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key];
      })
      this.$axios.get(ajaxUrl, { params }).then((res) => {
        console.log('全部数据', res);
        //将list里面的id 赋值给preselectId，用于判断是否是预选项目
        res.list.forEach(item => {
          item.preselectId = item.id;
        });
        this.tableData = res.list;

        this.total = res.totalRecord;
        if (this.searchFilter.dataSource == 1) {
          this.projectTypeList[0].num = res.totalRecord;
        }
        if (this.searchFilter.dataSource == 2) {
          this.projectTypeList[1].num = res.totalRecord;
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false
      })
    },

    hanlderPageType(list) {
      this.pageType = list.value;
      if (this.pageType == 2) {
        this.getProject();
      } else if (this.pageType == 1) {
        this.getPreselectProject();
      }
    },
    hanlderProjectType(list) {
      this.searchFilter.dataSource = list.value;
      if (this.pageType == 2) {
        this.getProject();
      } else if (this.pageType == 1) {
        this.getPreselectProject();
      }
    },
    // 表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#2c5282',
        color: '#fff',
        fontWeight: 600,
        fontSize: '14px'
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      if (this.pageType == 2) {
        this.getProject();
      } else if (this.pageType == 1) {
        this.getPreselectProject();
      }
    },

    handleCurrentChange(val) {
      this.currentPage = val
      if (this.pageType == 2) {
        this.getProject();
      } else if (this.pageType == 1) {
        this.getPreselectProject();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.project-approval-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);

  // 表格区域
  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .table-title {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          color: #2c5282;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          font-weight: 600;
          color: #1a365d;
          margin-right: 10px;
        }

        .el-tag {
          font-weight: normal;
        }
      }
    }

    // 表格样式
    .data-table {
      border-radius: 6px;
      overflow: hidden;
      font-size: 16px;

      ::v-deep .el-table__header-wrapper {
        th {
          background-color: #2c5282 !important;
        }
      }

      .code-text {
        color: #4a5568;
        font-size: 16px;
        letter-spacing: 0.5px;
      }

      .status-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;

        &.active {
          background: #48bb78;
          box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
        }

        &.inactive {
          background: #cbd5e0;
        }
      }

      .date-icon {
        color: #2c5282;
        margin-right: 4px;
      }

      ::v-deep .el-link {
        font-weight: 500;
      }
    }

    // 分页
    .pagination-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.project-type {
  padding: 10px 20px 0 20px;
  border-bottom: 1px solid #e2e8f0;
}

.project-type-list {
  display: inline-block;
  float: left;
  width: auto;
  text-align: center;
  margin-right: 30px;
  cursor: pointer;
  padding: 5px 12px;
  font-size: 16px;

  &.active {
    color: #fff;
    background: #2c5282;
    border-color: #2c5282;
  }

  &:hover {
    color: #fff;
    background: #2c5282;
    border-color: #2c5282;
  }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
  background: #2c5282;
  border-color: #2c5282;

  &:hover,
  &:focus {
    background: #1a365d;
    border-color: #1a365d;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
  color: #2c5282;

  &:hover {
    color: #1a365d;
  }
}
</style>